// extracted by mini-css-extract-plugin
export default {"returnButton":"returnButton_returnButton__qVJiX","returnButtonDark":"returnButton_returnButtonDark__lpeQz"};